import { config } from '@config';
import { logger } from '@services/logger';

export abstract class HttpServiceBase {
	protected logger = logger;
	constructor(protected path: string) {}

	protected getUrl() {
		return `${config.apiUrl}/${this.path}`;
	}
}
